import baustein from "baustein";


export default {
    enter: function() {
        return baustein.getInstanceOf("lyst-app");
    },

    update: function() {},

    exit: function() {
        console.error("The lyst-app route should never be exited!");
    },
};
